import Vue from 'vue'
import { RowModalHighlight } from '~/utils/row-modal-highlight'

export default () => {
  Vue.use(RowModalHighlight)
}
